// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select-type[data-v-796385c9]{padding-left:2.5rem}.select-type-icon[data-v-796385c9]{font-size:16px;position:absolute;top:0.5rem;left:1rem;pointer-events:none;color:var(--colors-gray-400)}\n", ""]);
// Exports
module.exports = exports;
